const FAQ = [
  {
    question: "What are pavers and why are they popular for outdoor spaces?",
    answer:
      "Pavers are interlocking concrete, brick, or natural stone units used to create durable, low-maintenance surfaces like patios, driveways, and walkways<IN_CITY_ZIP>. They’re favored for their visual appeal, drainage benefits, and long-lasting performance.",
  },
  {
    question: "How long do pavers last?",
    answer:
      "With proper installation and maintenance, pavers can last 25 to 50 years or more<IN_CITY_ZIP>. They’re designed to withstand weather, foot traffic, and shifting ground better than poured concrete.",
  },
  {
    question: "Can pavers be repaired if they get damaged?",
    answer:
      "Yes. One of the biggest advantages of pavers<IN_CITY_ZIP> is their ease of repair. Damaged or stained pavers can be individually replaced without affecting the surrounding layout.",
  },
  {
    question: "Do I need a permit for installing pavers in my yard?",
    answer:
      "Permits are usually not required for flat paver installations<IN_CITY_ZIP>, but if you're altering drainage, building steps, or installing retaining walls, city codes may apply. We handle all compliance and permitting when necessary.",
  },
  {
    question: "How do I maintain my pavers?",
    answer:
      "Maintenance is simple — sweep regularly, rinse as needed, and power wash occasionally<IN_CITY_ZIP>. Re-sanding joints and applying sealer every few years helps preserve appearance and stability.",
  },
  {
    question: "Can pavers be installed in a DIY project?",
    answer:
      "While it’s possible to install pavers yourself, achieving proper slope, compaction, and edge restraint is challenging. For lasting results<IN_CITY_ZIP>, professional installation is highly recommended.",
  },
  {
    question: "What types of pavers do you offer?",
    answer:
      "We install concrete, brick, and natural stone pavers in a variety of colors, shapes, and finishes<IN_CITY_ZIP>. Our team helps you choose the right style for your home’s architecture and usage.",
  },
  {
    question: "Do pavers add value to my property?",
    answer:
      "Yes. Professionally installed pavers<IN_CITY_ZIP> increase curb appeal and outdoor usability — both of which enhance resale value. They’re seen as a high-end upgrade compared to plain concrete.",
  },
  {
    question: "How much does paver installation cost?",
    answer:
      "Costs typically range from $15 to $30 per square foot<IN_CITY_ZIP>, depending on the paver material, pattern complexity, and site prep needed. We offer free estimates tailored to your project.",
  },
];

export default FAQ;
